import React, { Component } from 'react'
import Canvas from './Canvas'
import Sidebar from './Sidebar'

class Workshop extends Component {
	render() {
		return (
			<div className='Workshop vh-100 relative'>
				<Sidebar />
				<Canvas />
			</div>
		)
	}
}

export default Workshop



// WEBPACK FOOTER //
// ./src/components/Workshop.js